module.exports = __webpack_public_path__ + "img/gb946.prt.e69710ee.jpg";